export default __webpack_public_path__ + "static/media/transfusion-type5.c4102e96.jpg";